
export function sendAddTrackEvent (track, videoEl) {
  let event = null;
  try {
    event = new window.Event('addtrack');
  } catch (err) {
    // for IE11
    event = document.createEvent('Event');
    event.initEvent('addtrack', false, false);
  }
  event.track = track;
  videoEl.dispatchEvent(event);
}

export function clearCurrentCues (track) {
  if (track && track.cues) {
    while (track.cues.length > 0)
      track.removeCue(track.cues[0]);
  }
}



// WEBPACK FOOTER //
// ./src/utils/texttrack-utils.js